import { render, staticRenderFns } from "./WorkshopInfo.vue?vue&type=template&id=e3ba3fa8&scoped=true"
import script from "./WorkshopInfo.vue?vue&type=script&lang=js"
export * from "./WorkshopInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkshopInfo.vue?vue&type=style&index=0&id=e3ba3fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ba3fa8",
  null
  
)

export default component.exports